module.exports = __webpack_public_path__ + "img/checkmark-solid.8ceb8f78.svg";